import { useState, useEffect } from 'react';
import { BaseSelector } from '../../../domain/shared';
import Select from 'react-select';
import { groupsRepository } from '../../../infrastructure/repositories/groups/groupRepository';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    name: string;
}

export default function GroupSelector({ onChange, value, name }: Props) {
    const [groups, setGroups] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        groupsRepository.GetGroupsList().then((res) => {
            setIsLoading(false);
            setGroups(
                res.map((dt) => ({
                    label: dt.name,
                    value: dt.id,
                }))
            );
        });
    }, []);

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Grupo *
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                name='color'
                options={groups}
                onChange={(e) => {
                    onChange(name, e?.value);
                }}
                value={
                    groups.find((a) => a.value === value) ?? {
                        label: `Seleccione`,
                        value: 0,
                    }
                }
            />
        </div>
    );
}
